import { render, staticRenderFns } from "./ModeloList.vue?vue&type=template&id=bb733490"
import script from "./ModeloList.vue?vue&type=script&lang=js"
export * from "./ModeloList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports